const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

/**
 * List all parseable App Services (no settings fetch — fast).
 * @returns {Promise<Array>} List of { name, resourceGroup, tenantName, serviceType }
 */
export const listApps = async () => {
  const response = await fetch(`${API_BASE_URL}/api/envsettings/list-apps`);
  const data = await response.json();

  if (!response.ok) {
    const err = new Error(data?.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }

  return data;
};

/**
 * Preview injection — read-only conflict check.
 * @param {Object} request - { targets: [{appServiceName, resourceGroup}], settingName, settingValue }
 * @returns {Promise<Array>} List of InjectPreviewItem
 */
export const previewInject = async (request) => {
  const response = await fetch(`${API_BASE_URL}/api/envsettings/preview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  const data = await response.json();

  if (!response.ok) {
    const err = new Error(data?.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }

  return data;
};

/**
 * Apply injection — writes settings to Azure.
 * @param {Object} request - { targets, settingName, settingValue, slotSetting, overrides: {appName: bool} }
 * @returns {Promise<Array>} List of InjectApplyResult
 */
export const applyInject = async (request) => {
  const response = await fetch(`${API_BASE_URL}/api/envsettings/apply`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  const data = await response.json();

  if (!response.ok) {
    const err = new Error(data?.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }

  return data;
};
